import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';

import OptionButton from './OptionButton';

const DeliverBlankButton = ({ clickHandler, a11yAttributes }) => {
    return (<OptionButton
        iconClass="fa fa-file-o fa-fw"
        clickHandler={clickHandler}
        title={t('options.deliverBlank')}
        a11yAttributes={a11yAttributes}
    />);
};

DeliverBlankButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    a11yAttributes: PropTypes.object,
};

export default DeliverBlankButton;
